"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.URL_LIBRARIES_PARAM = exports.URL = exports.LOAD_CONFIG = void 0;
const constants_1 = require("../../../core/script/constants");
exports.LOAD_CONFIG = { sync: constants_1.SyncConfig.ASYNC, order: constants_1.OrderConfig.TOP };
exports.URL = 'https://maps.googleapis.com/maps/api/js?key=';
exports.URL_LIBRARIES_PARAM = 'libraries=places';
//# sourceMappingURL=constants.js.map